import nullGenerator from '../generators/null';

const nullType = nullGenerator;

export default nullType;

